export default __webpack_public_path__ + "static/media/iOS_Badge.8c4986ee.svg";